import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { LocalCafe as Icon } from '@mui/icons-material';

import { MenuItem } from 'types/global';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function Product({ selected, onSelect, open }: Props) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/products"
			selected={selected === MenuItem.Products}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.Products)}
		>
			<ListItemIcon>
				<Icon />
			</ListItemIcon>
			{open && <ListItemText primary={t('product:products')} />}
		</ListItem>
	);
}
